import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { BaseCell } from '../../../../../../../components';
import { RuleDataItem } from '../../lib/service';
import styles from './RulesPageTableVadalityCell.module.scss';

const RulesPageTableVadalityCell = ({ recurrence }: RuleDataItem) => {
  const formatDate = (date?: string | null): string => {
    if (!date) return 'indeterminado';
    return moment(date).format('DD/MM/YYYY');
  };

  return (
    <BaseCell className={classNames('font-size-75-regular', styles.wrapper)}>
      <p>De {formatDate(recurrence?.startingDate)} até</p>
      <p>{formatDate(recurrence?.expirationDate)}</p>
    </BaseCell>
  );
};

export default RulesPageTableVadalityCell;
